module.exports = {"missingPermission":"Leider haben Sie aktuell keinen Zugriff auf diese Seite.","contactAdministration":"Wenden Sie sich an den verantwortlichen Mitarbeiter in Ihrem Unternehmen, der diesen Trustpilot-Account verwaltet."}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/MissingPermission/localization/de-DE/strings.json
// module id = 1227
// module chunks = 0